<template>
    <l-popup>
          <div class="window-event">
            <div class="window__image" :style="{backgroundImage: 'url(' + getCover + ')'}" @click="openEvent(event)">
                <div class="window-users">
                    <div class="window-users__author" 
                    :style="{backgroundImage: 'url(' + event.author.avatar + ')'}" 
                    :title="event.author.firstname + ' ' + event.author.lastname"
                    @click.stop="openUser(event.author)"></div>
                    <div class="window-users__elem" 
                        v-for="user in event.users.slice(0, 3)" 
                        :key="user.id" 
                        :style="{backgroundImage: 'url(' + user.avatar + ')'}"
                        :title="user.firstname + ' ' + user.lastname"
                        @click.stop="openUser(user)"></div>
                    <div class="window-users__others" v-if="event.users && event.users.length > 2">+{{event.users.length - 3}}</div>
                </div>
                <div class="window-category">
                    <div class="categoryy" v-if="event.sports">
                    <div class="categoryy-item" 
                    v-for="sport in event.sports" 
                    :key="sport.id" 
                    @click.stop="setSport(sport)"
                    :class="sport.color">{{sport.ru}}</div>
                    </div>
                </div>
                
                <!-- <div class="window-join" @click.stop="openDestination(event)">
                    <p>Маршрут</p>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg"><path d="m371.244 114.479c0-24.831-20.188-45.031-45.004-45.031-24.814 0-45.003 20.201-45.003 45.031s20.188 45.031 45.003 45.031c24.816.001 45.004-20.2 45.004-45.031zm-45.004 15.032c-8.272 0-15.003-6.743-15.003-15.031s6.73-15.031 15.003-15.031 15.004 6.743 15.004 15.031-6.73 15.031-15.004 15.031z" fill="#ffffff" data-original="#000000" style="" class=""/><path d="m455.496 353.367h-278.118c-14.08 0-25.534-11.472-25.534-25.573s11.454-25.573 25.534-25.573h148.862c5.461 0 9.639-2.658 12.93-7.181l78.874-108.502c58.09-75.501 4.473-186.538-91.803-186.538-94.341 0-150.043 107.818-92.324 185.876l64.057 86.345h-120.596c-30.622 0-55.534 24.93-55.534 55.573s24.912 55.573 55.534 55.573h278.118c14.614 0 26.504 11.907 26.504 26.543s-11.89 26.543-26.504 26.543h-336.368c-6.686-26.154-30.433-45.547-58.623-45.547-33.362-.001-60.505 27.161-60.505 60.547s27.143 60.547 60.505 60.547c28.19 0 51.937-19.394 58.623-45.547h336.368c31.156 0 56.504-25.365 56.504-56.543s-25.348-56.543-56.504-56.543zm-197.574-185.506c-42.554-55.972-2.835-137.861 68.319-137.861 71.611 0 111.066 82.727 67.826 138.503-.126.162-67.07 92.261-67.153 92.375-.075-.1-68.915-92.917-68.992-93.017zm-197.417 314.139c-16.82 0-30.505-13.704-30.505-30.547s13.685-30.547 30.505-30.547 30.505 13.704 30.505 30.547-13.685 30.547-30.505 30.547z" fill="#ffffff" data-original="#000000" style="" class=""/></g></g></svg>
                </div> -->
            </div>
            <div class="window-body">

                <h4 class="window__title" @click="openEvent(event)">{{cutString(event.title, 70)}}</h4>
                
                <div class="window-info">
                    <p class="window-info__place" @click="openPlace(event)">{{ getPlace(event) }}</p>
                    <p class="window-info__date">{{getDate(
                    event.date_event
                    )}}</p>
                </div>
            </div>
            </div>
        </l-popup>
</template>
<script>
import { LPopup } from "vue2-leaflet";
export default {
    name: 'm-popup',
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    components: {
        "l-popup": LPopup
    },
    computed: {
        getCover() {
            return this.event.cover
                ? this.event.cover
                : 'https://images.unsplash.com/photo-1576967646301-b68a028ea17a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1353&q=80';
        },
    },
    methods: {
        async openEvent(event) {
            this.$route.name === 'event' && ((this.event.id + "&" + this.event.hash) === this.$route.params.hash) 
                ? '' 
                : await this.$router.push({name: "event", params: { hash: event.id + '&' + event.hash }});
            this.$store.dispatch("changeMode", false);
        },
        openPlace(event) {
            event.place ? this.$router.push({name: "place", params: { hash: event.place.id + '&' + event.place.hash }}) : '';
        },
        openUser(user) {
            this.$router.push({name: "user", params: { id: user.id }});
        },
        openDestination(event) {
            this.$store.dispatch('setDestinationId', event.id)
            this.$store.dispatch('setTransport', true)
        },
        setSport(sport) {
            sport.active = true;
            this.$store.dispatch("changeSports", sport);
        },
        getDate(val) {
            let date = this.$moment(val).locale("ru").calendar();
            return date;
        },
        getPlace(event) {
            return event.place ? this.cutString(event.place.title, 21) : event.country && event.state ? event.country + ', ' + event.state : this.cutString(event.latitude, 7) + ', ' + this.cutString(event.longitude, 7);
        },
        cutString(val, length) {
            if (val) {
                val = val.toString();
                val = val.length > length ? val.slice(0, length).concat("...") : val;
            }
            return val;
        }
    }
}
</script>